module.exports = __webpack_public_path__ + "img/open44.a6e92db6.png";